import { useRouter } from 'vue-router'
//import { BreadCrumb } from '@/src/interface/breadcrumb';
export default {
  props: {
    datas: {
      type: Array,
      default() {
        return [{
          text: '第一層',
          link: 'ui'
        },
        {
          text: '第0層',
          link: 'ui'
        }]
      }

    }
  },
  setup() {
    const router = useRouter();
    let onClick = (link) => {
      router.push(`/${link}`);
    }
    return {
      onClick,
    }
  }

}


